<div class="main-div">
    <mat-card class="z-depth center" flex="50">
        <mat-card-header>
            <mat-card-title>{{'Login' | translate}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form class="example-form">
                <table cellspacing="0" class="example-full-width">
                    <tr>
                        <td>
                            <mat-form-field class="example-full-width">
                                <input #pwd matInput name="password" placeholder="{{'Password' | translate}}" required
                                       type="password">
                            </mat-form-field>
                        </td>
                    </tr>
                </table>
                <div class="container-fluid">
                    <div class="row">
                        <div>
                            <button (click)="login(pwd.value)" color="primary" mat-raised-button
                                    type="submit">{{'Login' | translate}}
                            </button>
                        </div>
                        <div>
                            <mat-chip-list [hidden]="!invalidLogin" aria-label="Fish selection">
                                <mat-chip color="warn" selected>{{'Invalid password' | translate}}</mat-chip>
                            </mat-chip-list>
                        </div>
                    </div>
                </div>
            </form>
        </mat-card-content>

    </mat-card>
</div>






